import { memo } from 'react';

import { FloatingPanelMobile } from './FloatingPanelMobile';
import { areEqual } from './utils';

export default memo(FloatingPanelMobile, areEqual);
